import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import type { RowRenderProps } from 'react-table';

import type { FlavorKeys } from '@feathr/blackbox';
import { Flavors } from '@feathr/blackbox';
import { Chip } from '@feathr/components';
import { flavorColor, flavorIcon } from '@feathr/report_components';

import * as styles from './FlavorChip.css';

interface IProps extends RowRenderProps {
  flavor: FlavorKeys;
}

function FlavorChip({ flavor }: Readonly<IProps>): JSX.Element {
  const flvr = flavor || 'custom';
  const icon = flavorIcon(flvr);
  const color = flavorColor(flvr);
  const description = Flavors[flvr] || flvr;
  return (
    <Chip className={styles.chipFix} prefix={<FontAwesomeIcon icon={icon} />} theme={color}>
      {description}
    </Chip>
  );
}

export default FlavorChip;
